<div *ngIf="request" class="bdc-rtb-panel container-box p-3" [class.compact]="compact">
  <div class="d-flex align-items-center flex-wrap gap-2">
    <img *ngIf="inquiry?.inquirySource | inquirySourceIcon; let icon" [src]="icon" alt="" style="height: 18px" />
    <span class="text-bold" i18n>Booking.com booking request</span>
    <span
      class="badge badge-pill"
      [ngClass]="isPending ? 'badge-warning' : 'badge-secondary'"
      i18n-matTooltip
      matTooltip="Request status on Booking.com"
    >
      {{ statusLabel }}
    </span>
    <span
      *ngIf="isHeld"
      class="badge badge-pill badge-secondary-info"
      i18n-matTooltip
      matTooltip="The guest card is pre-authorised. The dates are closed on your other channels while the request is open."
      i18n
      >Dates held</span
    >
    <span
      *ngIf="isOpen && !isRtb"
      class="badge badge-pill badge-light"
      i18n-matTooltip
      matTooltip="An inquiry-type request: the dates stay open until the guest books, and the price can change."
      i18n
      >Dates not held</span
    >
  </div>

  <div class="d-flex flex-wrap gap-3 mt-2 text-sm">
    <div *ngIf="isPending && request.expires_at" [class.text-danger]="expiresSoon">
      <i class="far fa-clock mr-1"></i>
      <ng-container *ngIf="!isExpiredLocally" i18n>Respond by</ng-container>
      <ng-container *ngIf="isExpiredLocally" i18n>Expired at</ng-container>
      <strong class="ml-1">{{ request.expires_at | epoch : 'datetime' }}</strong>
    </div>
    <div *ngIf="request.request_status === 'APPROVED' && request.request_type === 'INQUIRY' && request.expires_at">
      <i class="far fa-clock mr-1"></i>
      <ng-container i18n>The guest can book until</ng-container>
      <strong class="ml-1">{{ request.expires_at | epoch : 'datetime' }}</strong>
    </div>
    <div *ngIf="request.total_price?.amount">
      <ng-container i18n>Total</ng-container>
      <strong class="ml-1">{{ request.total_price.amount | tokeetCurrency : request.total_price.currency }}</strong>
    </div>
    <div *ngIf="request.rejection_reason">
      <ng-container i18n>Declined</ng-container>: {{ rejectionReasonLabel || request.rejection_reason }}
    </div>
    <div class="text-muted">
      <ng-container i18n>Request</ng-container> #{{ request.request_id }}
      <ng-container *ngIf="request.reservation_id">
        · <ng-container i18n>Reservation</ng-container> #{{ request.reservation_id }}
      </ng-container>
    </div>
  </div>

  <div *ngIf="request.guest_message" class="guest-message mt-3">
    <div class="text-sm text-muted mb-1" i18n>Message from the guest</div>
    <div class="guest-message-text">{{ request.guest_message }}</div>
  </div>

  <div *ngIf="signals.length" class="mt-3">
    <div class="text-sm text-muted mb-1" i18n>About the guest (from Booking.com)</div>
    <div class="guest-signals text-sm">
      <div *ngFor="let signal of signals" class="guest-signal d-flex align-items-center gap-2">
        <i
          class="far fa-fw"
          [ngClass]="{
            'fa-check-circle text-success': signal.positive === true,
            'fa-exclamation-circle text-danger': signal.positive === false,
            'fa-info-circle text-muted': signal.positive === null
          }"
        ></i>
        <span>{{ signal.label }}:</span>
        <strong>{{ signal.value }}</strong>
      </div>
    </div>
  </div>

  <div *ngIf="isPending" class="decision mt-3 pt-3 border-top">
    <div class="d-flex align-items-center gap-3" [class.flex-wrap]="compact">
      <ng-container *ngxPermissionsOnly="['canEditInquiry']">
        <div class="d-flex gap-2 flex-shrink-0">
          <app-button
            icon="fal fa-check-square"
            class="btn btn-secondary-info"
            [loading]="isLoading"
            [disabled]="1 | isReadonlyRole"
            (click)="onApprove()"
            i18n
            >Approve</app-button
          >
          <app-button
            icon="fal fa-ban"
            class="btn btn-secondary-danger"
            [disabled]="isLoading || (1 | isReadonlyRole)"
            (click)="onDecline()"
            i18n
            >Decline</app-button
          >
        </div>
      </ng-container>
      <p class="text-muted text-sm mb-0 bdc-rtb-disclaimer">{{ disclaimer }}</p>
    </div>
  </div>
</div>
